<template>
  <div class="block-chain-co-chain">
    <action-bar>
      <search v-model="inputContent" placeholder="请输入交易ID" @onSearch="handleSearch"></search>
      <btn-style :btn-list="btnList" class="btn-list-style"></btn-style>
    </action-bar>
    <normal-table
      ref="commonTable"
      :table-col="tableCol"
      :table-data="list"
      :operator="operator"
      :operate-col="operateCol"
      :show-edit="true"
      :paging="paging"
      @pagination="handleSizeOrPageChange"
    >
      <template slot="TxStatus" slot-scope="{ param }">
        <span class="tx-status" :class="param.row.TxStatus | transStatusClass">{{
          param.row.TxStatus | transStatus($constants.EMPTY)
        }}</span>
      </template>
      <template slot="Status" slot-scope="{ param }">
        <span>{{
          param.row.Status === 0 ? '上链中' : param.row.Status === 1 ? '已上链' : '上链失败'
        }}</span>
      </template>
    </normal-table>
    <invoke-dialog ref="invokeDialog" @update:list="getList()"></invoke-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import invokeDialog from './invoke'
import auth from '@/auth/index'
export default {
  name: 'Index',
  components: {
    invokeDialog
  },
  filters: {
    transStatus: function(value, defaultVal) {
      if (value == 0) {
        return '成功'
      } else if (value == 1) {
        return '失败'
      } else {
        return defaultVal
      }
    },
    transStatusClass: function(value) {
      if (value == 0) {
        return 'is-success'
      } else if (value == 1) {
        return 'is-failed'
      } else {
        return ''
      }
    }
  },
  data() {
    return {
      inputContent: '',
      btnList: [
        {
          btnContent: '发起上链',
          click: () => {
            return this.upperChain()
          },
          icon: 'icon-gen',
          auth: auth.blockchain.checkDetail.coChainManage.doCoChain
        }
      ],
      // 设置table的列
      tableCol: [
        {
          prop: 'updateAt',
          label: '更新时间',
          formatter: row => {
            return this.formatTime(row)
          },
          minWidth: 196
        },
        {
          prop: 'TxId',
          label: '交易ID',
          minWidth: 324
        },
        {
          prop: 'OrgName',
          label: '发起组织',
          minWidth: 136
        },
        {
          prop: 'UserName',
          label: '发起用户',
          minWidth: 87
        },
        {
          prop: 'ContractName',
          label: '合约',
          minWidth: 156
        },
        {
          prop: 'Status',
          label: '上链状态',
          slotName: 'Status',
          minWidth: 112
        },
        {
          prop: 'TxStatus',
          label: '交易状态',
          slotName: 'TxStatus',
          minWidth: 102
        }
      ],
      // table的基本操作
      operator: [
        {
          text: '查看',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          },
          icon: 'icon-check'
        }
      ],
      operateCol: {
        minWidth: 54
      }
    }
  },
  computed: {
    ...mapState({
      list: state => state.chain.upper_chain_list,
      paging: state => state.chain.upper_chain_paging
    })
  },
  mounted() {
    this.getList()
  },
  methods: {
    ...mapActions(['getUpperChainLists']),
    getList(limit = 10, offset = 0) {
      let params = {
        chainId: this.$route.query.chainId,
        status: -1,
        txStatus: -1,
        txId: this.inputContent,
        offset,
        limit
      }
      this.getUpperChainLists(params)
    },
    handleSizeOrPageChange(data) {
      const { offset, limit } = data
      this.getList(limit, offset * limit)
    },
    handleSearch(value) {
      this.inputContent = value
      this.getList()
    },
    refresh() {
      this.inputContent = ''
      this.getList()
    },
    upperChain() {
      this.$refs.invokeDialog.handleOpen()
    },
    formatTime(row) {
      return this.$utils.dateFormat('YYYY-mm-dd HH:MM', row.updateAt)
    },
    goDetail(row) {
      this.$router.push({
        name: 'txnDetail',
        query: {
          txId: row.TxId,
          chainId: this.$route.query.chainId,
          hideActionBar: true
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'block-chain-co-chain',
  (
    --block-chain-co-chain-list-operate-color: #45c2ff,
    --block-chain-co-chain-list-operate-danger-color: #e95757,
    --block-chain-co-chain-list-status-success: #55da62,
    --block-chain-co-chain-list-status-failed: #e95757
  ),
  (
    --block-chain-co-chain-list-operate-color: #45c2ff,
    --block-chain-co-chain-list-operate-danger-color: #e95757,
    --block-chain-co-chain-list-status-success: #55da62,
    --block-chain-co-chain-list-status-failed: #e95757
  )
);
.block-chain-co-chain {
  @include adaptation(
    (
      --block-chain-co-chain-unavaliable-height: 166px
    )
  );
  --block-chain-co-chain-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--block-chain-co-chain-unavaliable-height)
  );
  .btn-list-style {
    width: 100%;
  }

  .normal-table-wrap {
    height: 100%;
    min-height: var(--block-chain-co-chain-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--block-chain-co-chain-min-height);
      }

      .normal-table {
        height: 100%;
        min-height: var(--block-chain-co-chain-min-height);

        .tx-status {

          &.is-success {
            color: var(--block-chain-co-chain-list-status-success);
          }

          &.is-failed {
            color: var(--block-chain-co-chain-list-status-failed);
          }
        }

        .operate-item {
          color: var(--block-chain-co-chain-list-operate-color);

          &.operate-danger {
            color: var(--block-chain-co-chain-list-operate-danger-color);
          }
        }
      }
    }
  }
}
</style>
